import {FC, memo} from "react";
import {Box, Button, chakra, Flex, HStack, IconButton, useDisclosure, VisuallyHidden, VStack} from "@chakra-ui/react";
import { LuMenu } from "react-icons/lu";
import { CloseButton } from "../ui/close-button";
import { useColorModeValue } from "../ui/color-mode";
import { useTranslation } from "react-i18next";

type Props = {
    onClickHeader: () => void;

    onClickNavigation: (path: String) => void;
}

export const Header: FC<Props> = memo((props) => {
    const {t} = useTranslation();
    const bg = useColorModeValue("white", "gray.800");
    const mobileNav = useDisclosure();
    const menuList = [
        { title: t("home.title"), action: () => props.onClickNavigation("/") },
        { title: t("activation.title"), action: () => props.onClickNavigation("/Activation") },
        { title: t("contact.title"), action: () => window.open(t("contact.link")) },
    ]
    const createMenuElement = (isWFull = false) => {
        var list = [];
        for (let i = 0; i < menuList.length; i++) {
            const menu = menuList[i];
            if (isWFull) {
                list.push(<Button w="full" variant="ghost" onClick={menu.action}>{menu.title}</Button>);
            } else {
                list.push(<Button variant="ghost" onClick={menu.action}>{menu.title}</Button>);
            }
        }

        return list;
    }

    return (
        <chakra.header
          bg={bg}
          w="full"
          px={{
            base: 2,
            sm: 4,
          }}
          py={4}
          shadow="md"
        >
          <Flex alignItems="center" justifyContent="space-between" mx="auto">
            <Flex>
              <chakra.a
                href="/"
                title={t("app")}
                display="flex"
                alignItems="center"
              >
                {/* <LuMenu/> */}
                <VisuallyHidden>{t("app")}</VisuallyHidden>
              </chakra.a>
              <chakra.h1 fontSize="xl" fontWeight="medium" ml="2">
                {t("app")}
              </chakra.h1>
            </Flex>
            <HStack display="flex" alignItems="center" spaceX={1}>
              <HStack
                spaceX={1}
                mr={1}
                color="brand.500"
                display={{
                  base: "none",
                  md: "inline-flex",
                }}
              >
                { createMenuElement() }
              </HStack>
              {/* <Button colorScheme="brand" size="sm">
                Get Started
              </Button> */}
              <Box
                display={{
                  base: "inline-flex",
                  md: "none",
                }}
              >
                <IconButton
                  display={{
                    base: "flex",
                    md: "none",
                  }}
                  aria-label="Open menu"
                  fontSize="20px"
                  color="gray.800"
                  _dark={{
                    color: "inherit",
                  }}
                  variant="ghost"
                  onClick={mobileNav.onOpen}
                ><LuMenu /></IconButton>
  
                <VStack
                  pos="absolute"
                  top={0}
                  left={0}
                  right={0}
                  display={mobileNav.open ? "flex" : "none"}
                  flexDirection="column"
                  p={2}
                  pb={4}
                  m={2}
                  bg={bg}
                  spaceY={3}
                  zIndex={1000}
                  rounded="sm"
                  shadow="sm"
                >
                  <CloseButton
                    aria-label="Close menu"
                    onClick={mobileNav.onClose}
                  />
                  
                  { createMenuElement(true) }
                </VStack>
              </Box>
            </HStack>
          </Flex>
        </chakra.header>
    );
});